import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/expansion-groups")({
	component: ExpansionGroupsLayout,
})

function ExpansionGroupsLayout() {
	return <Outlet />
}
